import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Storage } from '@ionic/storage';
import { WpProvider } from "../../providers/wp/wp";

import { RoomServiceOrderModal } from './room-service-order';

import * as _ from 'lodash';
import { TabUpdateProvider } from '../../providers/tab-update/tab-update.service';

/**
 * Generated class for the InRoomDiningPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-room-service',
  templateUrl: 'room-service.html',
})
export class RoomServicePage {

  phcApp;
  amenities;
  activeMenu;
  currentOrder = [];

  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public wpProvider: WpProvider,
    public storage: Storage,
    private tabUpdate: TabUpdateProvider
  ) {
    this.phcApp = this.wpProvider.app;
    this.amenities = this.phcApp.room_service;
    console.log(this.amenities);
  }

  presentOrderModal(menu) {
    console.log(this.phcApp.getIrdMenu(menu.ID));
    let orderModal = this.modalCtrl.create(RoomServiceOrderModal, { order: this.currentOrder });
    orderModal.onDidDismiss(order => {
      console.log(order);
      if(order) this.doneOrder();
    });
    orderModal.present();
  }

  getSectionItems(sectionIds){
    return this.phcApp.getIrdMenuItems(sectionIds);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InRoomDiningPage');
  }

  menuCardBgStyle(menu){
    return {
      boxShadow: `inset 0 0 0 1000px rgba(0,0,0,${ parseInt(menu.black_overlay_opacity) / 100 })`,
    }
  }

  addToOrder(item){
    if(!_.find(this.currentOrder, { ID: item.ID })) {
      this.currentOrder.push(item);
    }
  }

  requestItem(){
    alert('Your item is on its way!');
  }


  doneOrder(){
    alert('Thank you! Your order is on its way.');
  }

}



// WEBPACK FOOTER //
// ./src/pages/room-service/room-service.ts